"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _Label = _interopRequireDefault(require("../Label"));
var _SpacedLabel = _interopRequireDefault(require("../SpacedLabel"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _constants = require("../constants");
var _Autocomplete = _interopRequireDefault(require("./Autocomplete.style"));
var _dec, _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let Autocomplete = (_dec = (0, _reactJss.default)(_Autocomplete.default), _dec(_class = (0, _reactClickOutside.default)(_class = class Autocomplete extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: !!props.value,
      passShow: false,
      focus: false,
      error: !!props.value,
      activeItem: -1
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleClickRightText = this.handleClickRightText.bind(this);
    this.handleSearchListScroll = this.handleSearchListScroll.bind(this);
    this.fieldRef = _react.default.createRef();
  }
  static getDerivedStateFromProps(props, state) {
    if (state.selected && !props.value || !state.selected && props.value) {
      return {
        selected: !!props.value
      };
    }
    return null;
  }
  componentDidMount() {
    const {
      autoFocus
    } = this.props;
    if (!autoFocus) return;
    setTimeout(() => {
      if (!this.input) return; // Additional check in case if component is already unmounted
      this.input.focus();
      this.input.click(); // Trigger to open the popup
    }, 100);
  }

  // Handler for click outside of component
  handleClickOutside(e) {
    const el = e.target;
    const searchListEl = document.getElementById('searchList');
    if (this.txtEl && this.txtEl.contains(el) || searchListEl && searchListEl.contains(el)) {
      return;
    }
    const {
      id,
      value,
      error,
      onBlur,
      onChange
    } = this.props;
    if (!value && !this.input.value) {
      this.setState({
        selected: false
      });
    }
    this.setState({
      focus: false
    });
    if (value && value !== value.trim()) {
      onChange({
        id,
        value: value.trim(),
        error
      });
    }
    onBlur();
  }
  handleFocus() {
    const {
      visibility,
      onFocus
    } = this.props;
    if (!_utils.default.isVisible(visibility)) return;
    this.setState({
      selected: true,
      focus: true
    });
    onFocus(this.props.id);
  }
  handleChange(e) {
    const {
      id,
      onChange
    } = this.props;
    const {
      error,
      value
    } = this.formatAndCheck(e.target.value);
    onChange({
      id,
      value,
      error
    });
  }
  handleKeyDown(e) {
    const {
      value,
      onKeyDown
    } = this.props;
    const hotKeys = ['ArrowDown', 'ArrowUp', 'Enter'];
    // delete
    if (e.key === 'Backspace' && value === '') {
      this.removeChip();
    }
    if (hotKeys.indexOf(e.key) !== -1) {
      this.selectionUsingButtons(e);
    }
    onKeyDown(e);
  }
  handleClickRightText() {
    const {
      onClickRightText
    } = this.props;
    onClickRightText();
  }
  removeChip() {
    const children = this.props.chipsItems();
    if (!children || children.length === 0) return;
    this[`chipRef${children.length - 1}`].props.closeClick();
  }
  selectionUsingButtons(e) {
    e.preventDefault();
    const children = this.props.searchResult();
    if (!children) return;
    const childrenList = children.props.children;
    const {
      activeItem
    } = this.state;
    let newActiveItem = activeItem;
    if (e.key === 'ArrowDown' && activeItem < childrenList.length - 1) {
      newActiveItem += 1;
    } else if (e.key === 'ArrowUp' && activeItem > 0) {
      newActiveItem -= 1;
    }
    if (!childrenList[newActiveItem]) return;
    const item = this[`itemRef${childrenList[newActiveItem].props.id}`];
    if (e.key === 'Enter') {
      const {
        id,
        value,
        avatar,
        visibility
      } = item.props;
      if (visibility === 'disabled') return;
      item.props.onClick({
        id,
        value,
        avatar,
        error: false
      });
      newActiveItem = 0;
    }
    this.setState({
      activeItem: newActiveItem
    }, this.scrollList(_reactDom.default.findDOMNode(item)));
  }
  scrollList(item) {
    const container = _reactDom.default.findDOMNode(this.containerSearchList);
    const heightContainer = container.offsetHeight;
    const heightItem = item.offsetHeight;
    const scrollPosition = item.offsetTop < heightContainer - heightItem * 3 ? 0 : item.offsetTop - (heightContainer - heightItem * 3);
    _utils.default.scrollTo(container, scrollPosition, 100);
  }
  formatAndCheck(value) {
    let error = false;
    const {
      length,
      required
    } = this.props;
    if (!value.length) {
      return {
        error,
        value
      };
    }
    // Restriction by string length
    if (length && value.length >= length) {
      value = value.substr(0, length);
    }
    if (required && (!value || !value.length)) {
      error = true;
    }
    return {
      error,
      value
    };
  }
  renderChips(chipsItems) {
    const children = chipsItems();
    if (!children) return null;
    return _react.default.Children.map(children, (child, index) => _react.default.cloneElement(child, {
      ref: el => {
        this[`chipRef${index}`] = el;
      },
      onClick: e => {
        e.stopPropagation();
        if (child.onClick) child.onClick(e);
      }
    }));
  }
  renderRightText(text, classes) {
    if (!text) return null;
    return /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: text,
      className: classes,
      onClick: e => {
        e.stopPropagation();
        this.handleClickRightText(e);
      }
    });
  }
  renderHelperText(helperText, classes) {
    if (!helperText) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, helperText);
  }
  handleMouseMove() {
    const {
      activeItem
    } = this.state;
    if (activeItem !== -1) {
      this.setState({
        activeItem: -1
      });
    }
  }
  handleSearchListScroll(e) {
    if (!this.props.onSearchListScroll) return;
    if (!this.props.scrollBoundary) {
      this.props.onSearchListScroll(e);
      return;
    }
    const {
      scrollTop,
      clientHeight,
      scrollHeight
    } = this.containerSearchList;
    const scrollBottom = scrollHeight - (scrollTop + clientHeight);
    if (scrollBottom >= this.props.scrollBoundary) return;
    this.props.onSearchListScroll(e);
  }
  renderSearchList(searchTitle, searchResult, classes) {
    const children = searchResult();
    const title = searchTitle();
    const index = this.state.activeItem;
    if (!children) return null;
    return () => /*#__PURE__*/_react.default.createElement("div", {
      id: "searchList",
      className: (0, _clsx.default)(classes, 'searchList'),
      onMouseMove: this.handleMouseMove,
      onScroll: this.handleSearchListScroll,
      ref: el => {
        this.containerSearchList = el;
      }
    }, title, _react.default.Children.map(children.props.children, child => {
      var _child$props, _children$props, _children$props$child, _children$props$child2, _children$props$child3;
      if (!child) return null;
      if (!(child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id)) return child;
      const activeItem = (children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : (_children$props$child = _children$props.children) === null || _children$props$child === void 0 ? void 0 : (_children$props$child2 = _children$props$child[index]) === null || _children$props$child2 === void 0 ? void 0 : (_children$props$child3 = _children$props$child2.props) === null || _children$props$child3 === void 0 ? void 0 : _children$props$child3.id) || null;
      return _react.default.cloneElement(child, {
        ref: el => {
          this[`itemRef${child.props.id}`] = el;
        },
        activeItem
      });
    }));
  }
  renderLabelComponent() {
    const {
      label,
      tooltip,
      classes,
      unspaced
    } = this.props;
    if ((0, _react.isValidElement)(label)) return label;
    if (!label) return null;
    const wrapperClassName = (0, _clsx.default)(classes.label, tooltip ? 'tooltip' : 'label', {
      unspaced
    });
    return tooltip ? /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      size: "xxsmall",
      alignItems: "center",
      className: wrapperClassName
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, label), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      value: tooltip,
      topLevel: true
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "small",
      type: "info",
      colorType: _constants.COLOR.gray
    }))) : /*#__PURE__*/_react.default.createElement("div", {
      className: wrapperClassName
    }, label);
  }
  render() {
    const {
      classes,
      className,
      id,
      size,
      value,
      visibility,
      bordered,
      error,
      placeholder,
      helperText,
      rightText,
      onKeyUp,
      onKeyPress,
      chipsItems,
      searchTitle,
      searchResult,
      unspaced,
      startAdornment,
      endAdornment,
      color,
      dataTestId
    } = this.props;
    const {
      focus,
      selected
    } = this.state;
    const tabIndex = _utils.default.isVisible(visibility) ? 0 : -1;
    const txtClasses = (0, _clsx.default)(className, classes.autocomplete, classes[size], {
      error: !!error
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    }, {
      focus: !!focus
    }, {
      selected: !!selected || chipsItems
    }, {
      bordered
    }, {
      unspaced
    });
    const helperTextClasses = (0, _clsx.default)(classes.helperText, {
      error
    });
    const searchListClasses = classes.searchList;
    const rightTextClasses = (0, _clsx.default)(classes.rightText, 'rightText');
    const chipsClasses = 'chipsContainer';

    /**
     * For backword compatibility with rightText prop - input paddings applied on different divs
     * @warning If you are using rightText props - adornments will not work correctly
     */
    const paddingClass = (0, _clsx.default)(classes.paddings, classes[size], {
      bordered
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: txtClasses,
      ref: el => {
        this.txtEl = el;
      },
      "data-testid": dataTestId ? `${dataTestId}-container` : undefined
    }, this.renderLabelComponent(), /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
      content: this.renderSearchList(searchTitle, searchResult, searchListClasses),
      anchors: {
        binding: _Popover.default.ANCHOR.left_bottom,
        content: _Popover.default.ANCHOR.left_top
      },
      fitToBindingElementWidth: true,
      verticalPlacingOnly: true,
      topLevel: this.props.popoverOnTop,
      bindingElementRef: this.fieldRef,
      contentClassName: (0, _clsx.default)(classes.popoverContent, {
        unspaced
      }),
      padding: 4
    }, this.props.popoverOptions), ({
      onClick
    }) => /*#__PURE__*/_react.default.createElement("div", {
      ref: this.fieldRef,
      className: (0, _clsx.default)(classes.field, 'field', rightText ? paddingClass : '', classes[`backgroundColor__${color}`]),
      onClick: onClick
    }, startAdornment || null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.fieldInput, rightText ? '' : paddingClass)
    }, this.renderChips(chipsItems, chipsClasses), /*#__PURE__*/_react.default.createElement("input", {
      ref: el => this.input = el,
      value: value,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      autoComplete: "off",
      disabled: visibility === 'disabled',
      tabIndex: tabIndex,
      placeholder: placeholder,
      onKeyPress: onKeyPress,
      onKeyDown: this.handleKeyDown,
      onKeyUp: onKeyUp,
      "data-testid": dataTestId
    })), this.renderRightText(rightText, rightTextClasses), endAdornment || null)), this.renderHelperText(helperText, helperTextClasses));
  }
}) || _class) || _class);
Autocomplete.Label = _SpacedLabel.default;
Autocomplete.COLOR = _constants.COLOR;
Autocomplete.defaultProps = {
  visibility: 'visible',
  size: 'medium',
  error: false,
  bordered: false,
  chipsItems: null,
  searchResult: null,
  popoverOptions: {},
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onClickRightText: () => {},
  onKeyPress: () => {},
  onKeyUp: () => {},
  onKeyDown: () => {},
  searchTitle: () => {}
};
var _default = exports.default = Autocomplete;